import * as yup from 'yup';

import http from '@/utils/http';

interface CodeValidationResult {
  isValid: boolean;
  isExists: boolean;
}

const INVALID_MESSAGE = 'Невірний формат';
const ALREADY_USED_MESSAGE = 'Вже використовується';

/**
 * Async uniqueness check of the shared organization edit form (`RbacOrganizationApiContext.validateCodeFn`) against
 * Households Billing's shared RBAC `GET /organizations/eic/validate` (GSB-8308), the only code that form checks. The
 * http instance's base is that API (`/api`).
 */
export const validateOrganizationCodeFn = (
  key: 'eic',
  isStructurallyValid: (value: string) => boolean,
  excludeId?: string,
) =>
  async function (
    this: yup.TestContext,
    value?: string | null,
  ): Promise<boolean | yup.ValidationError> {
    if (!value || !isStructurallyValid(value)) return true;

    try {
      const params = new URLSearchParams({ [key]: value });
      if (excludeId) params.set('excludeId', excludeId);

      const { data } = await http<CodeValidationResult>({
        url: `/organizations/${key}/validate?${params.toString()}`,
      });

      if (!data.isValid) return this.createError({ message: INVALID_MESSAGE });
      if (data.isExists)
        return this.createError({ message: ALREADY_USED_MESSAGE });
      return true;
    } catch {
      return false;
    }
  };
